import axiosInstance from "./axiosInstance";

export const makeGet = async (endpoint:string)=>{
    const resp = await axiosInstance.get(endpoint,{
        headers:{
            "Content-Type":"application/json",
        }
    });

    return resp.data;
}

export const makePost = async (endpoint :string,body:string)=>{
    const resp = await axiosInstance.post(endpoint,body,{
        headers:{
            "Content-Type":"application/json",
        }
    })
    return resp.data;
}

export const makeAuthenticatedGet = async (endpoint:string)=>{
    const token = localStorage.getItem('token');
    const response = await axiosInstance.get(endpoint, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
}

export const makeAuthenticatedPost = async (endpoint : string , body : any)=>{
    const token = localStorage.getItem('token');
    const response = await axiosInstance.post(endpoint, body, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
}

export const makeAuthenticatedPatch = async (endpoint : string , body : any)=>{
  const token = localStorage.getItem('token');
  const response = await axiosInstance.patch(endpoint, body, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
}

export const makeAuthenticatedDelete = async (endpoint: string) => {
  const token = localStorage.getItem('token');
  const response = await axiosInstance.delete(endpoint, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  return response.data;
}

export const makePrivilagedPost = async (endpoint : string , body : any,secret:any)=>{
    const token = secret;
    const response = await axiosInstance.post(endpoint, body, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
}

export const makePrivilagedPostForFile = async(endpoint:string , body:FormData,secret:any)=>{
    const token = secret;
    const response = await axiosInstance.post(endpoint, body, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
}

export const makeAuthenticatedPostForFile = async(endpoint:string , body:FormData)=>{
    const token = localStorage.getItem('token');
    const response = await axiosInstance.post(endpoint, body, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
}

export const makeAuthenticatedPostForFileResponse = async(endpoint:string, body:FormData)=>{
    const token = localStorage.getItem('token');
    return axiosInstance.post(endpoint, body, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
}

export const makeAuthenticatedPatchForFile = async(endpoint:string , body:FormData)=>{
  const token = localStorage.getItem('token');
  const response = await axiosInstance.patch(endpoint, body, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
}

export const makePostForFile = async (endpoint:string , body : FormData)=>{
    const response = await axiosInstance.post(endpoint,body,{
        headers:{
           'Content-Type': 'multipart/form-data'
        }
    });

    return response.data;
}
